"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoilEnrichmentCreationRequest = void 0;
const soilEnrichmentConstants_1 = require("../constants/soilEnrichmentConstants");
class SoilEnrichmentCreationRequest {
    constructor() {
        this.soilEnrichmentConstants = new soilEnrichmentConstants_1.SoilEnrichmentConstants();
    }
}
exports.SoilEnrichmentCreationRequest = SoilEnrichmentCreationRequest;
